import { Component }              from '@angular/core';
import { MatDialogRef }            from '@angular/material';
import { Globals }                from './../common/globals';
import { PortalTypeEnum }         from '../login/login.model';

@Component({
  selector: 'sa-user-dialog',
  template: require('./user-dialog.component.html'),
  styles: [require('./user-dialog.component.scss')]
})
export class UserDialogComponent {
  public model: any = {};

  public roles = [];

  public trainRoles = [];

  public busRoles = [];

  public portalRoles = [];

  public dataReady = false;

  public currentRolePortal = false; // for PortalKoordinator role - this role can change only NOT portal roles (= train roles)

  public portalTypes = PortalTypeEnum;

  constructor(public dialogRef: MatDialogRef<UserDialogComponent>, public globals: Globals) {
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/user-dialog/user-dialog.component.ts